import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import Button from "../../Components/Button";
import PlayStoreIcon from "../../assets/images/google-play.svg";
import AppleIcon from "../../assets/images/apple.svg";
import QRCode from "../../assets/images/qr_code.png";
import LogoBlue from "../../assets/images/logo-blue.svg";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #ffffff;
  line-height: 56px;
`;

const SpanText = styled.span`
  font-weight: 200;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
`;

const Footer = () => {
  return (
    <>
      <Container
        style={{
          marginTop: "40px",
          backgroundColor: "#1E1E1E",
        }}
        id="section-3"
      >
        <Row
          xs="1fr"
          sm="1fr"
          md="60% auto"
          lg="60% auto"
          xl="60% auto"
          style={{ marginTop: "60px", marginBottom: "60px" }}
          gap="170px"
        >
          <div>
            <Title>
              Pronto para <span style={{ color: "#41FFA4" }}>revolucionar</span>{" "}
              a gestão dos seus imóveis?
            </Title>
            <SpanText>Cadastre-se agora e experimente o Room</SpanText>
            <Row
              xs="1fr"
              sm="1fr"
              md="1fr 1fr"
              lg="1fr 1fr"
              xl="1fr 1fr"
              style={{ marginTop: "30px", maxWidth: "340px" }}
            >
              <Button
                style={{
                  borderRadius: "40px",
                  backgroundColor: "transparent",
                  border: "1px solid #ffffff",
                }}
                onClick={() => {
                  window.location.href =
                    "https://play.google.com/store/apps/details?id=com.mario.dunda.upperloc";
                }}
              >
                <img
                  src={PlayStoreIcon}
                  width={"20px"}
                  style={{ marginRight: "10px" }}
                />
                Google Play
              </Button>
              <Button
                style={{
                  borderRadius: "40px",
                  backgroundColor: "transparent",
                  border: "1px solid #ffffff",
                }}
                onClick={() => {
                  window.location.href =
                    "https://apps.apple.com/us/app/room-aluguel-contratos/id6742391411";
                }}
              >
                <img
                  src={AppleIcon}
                  width={"20px"}
                  style={{ marginRight: "10px" }}
                />
                App Store
              </Button>
            </Row>
          </div>
          {window.innerWidth > 576 && (
            <img
              style={{ border: "4px solid #4162fd", borderRadius: "8px" }}
              src={QRCode}
              width={"100%"}
            />
          )}
        </Row>
      </Container>
      <Container
        style={{
          textAlign: "center",
        }}
        id="section-3"
      >
        <Row
          xs="1fr"
          sm="1fr"
          md="1fr 1fr"
          lg="1fr 1fr"
          xl="1fr 1fr"
          style={{
            marginTop: "40px",
            marginBottom: "30px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img src={LogoBlue} width={"150px"} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{ fontWeight: 200, textAlign: "right", fontSize: "20px" }}
            >
              © 2025 Room
            </span>
            <span
              style={{
                fontWeight: 700,
                textAlign: "right",
                textDecoration: "underline",
                fontSize: "15px",
              }}
            >
              contato@meuroom.com.br
            </span>
          </div>
        </Row>
        <hr style={{ borderColor: "#D9D9D9" }} />
        <Row
          xs="1fr"
          sm="1fr 1fr"
          md="1fr 1fr"
          lg="1fr 1fr 1fr 1fr"
          xl="1fr 1fr 1fr 1fr"
          style={{
            marginTop: "40px",
            marginBottom: "30px",
            justifyContent: "space-evenly",
            alignItems: "center",
            width: "70%",
          }}
        >
          <a
            href="/privacy-policy"
            style={{
              cursor: "pointer",
              fontSize: "15px",
              color: "#000000",
              textDecoration: "none",
            }}
          >
            Política de privacidade
          </a>
          <a
            href="/term-of-use"
            style={{
              cursor: "pointer",
              fontSize: "15px",
              color: "#000000",
              textDecoration: "none",
            }}
          >
            Termos de uso
          </a>
          <a
            href="/term-delete-account"
            style={{
              cursor: "pointer",
              fontSize: "15px",
              color: "#000000",
              textDecoration: "none",
            }}
          >
            Exclusão de conta
          </a>
          <a
            href="/#section-4"
            style={{
              cursor: "pointer",
              fontSize: "15px",
              color: "#000000",
              textDecoration: "none",
            }}
          >
            Ajuda
          </a>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
